import React from 'react';
import { ClubRPayContained } from '@rakutenfrance/shared-svg';
import { CardContainer, CenteredTitle, CircleContainer, CircleText, ClubRContainer, Image, ImageContainer, CheckImageContainer, TextContainer, TitleContainer, Title, CheckIcon, } from './Carousel.style';
import Check from '@mui/icons-material/Check';
const CircleNumber = ({ number }) => (React.createElement(CircleContainer, null,
    React.createElement(CircleText, null, number)));
const FirstCard = () => (React.createElement(CardContainer, { padding: 16 },
    React.createElement(TitleContainer, null,
        React.createElement(ClubRContainer, null,
            React.createElement(ClubRPayContained, { height: "22" })),
        React.createElement(Title, null, "Comment cumuler du cashback et des promotions avec le Club R ?")),
    React.createElement(ImageContainer, { bottom: -4, isCenter: true },
        React.createElement("img", { src: "https://fr.shopping.rakuten.com/visuels/0_next-common/club-r-pay/cadeau392x392.png", width: 196 }))));
const SecondCard = () => (React.createElement(CardContainer, { padding: 40 },
    React.createElement(TitleContainer, null,
        React.createElement(CircleNumber, { number: 1 }),
        React.createElement(CenteredTitle, { weight: 400 },
            "Cliquez sur ",
            React.createElement("b", { style: { display: 'block' } }, "\u201Cj\u2019en profite\u201D"),
            " ou ",
            React.createElement("b", null, "\u201Cvoir le code\u201D"))),
    React.createElement(ImageContainer, { left: -50, bottom: 8, isHiddenOverflow: true },
        React.createElement(Image, { src: "https://fr.shopping.rakuten.com/visuels/0_next-common/club-r-pay/bras350x239.png", width: 175, height: 111 }))));
const ThirdCard = () => (React.createElement(CardContainer, { padding: 40 },
    React.createElement(TitleContainer, null,
        React.createElement(CircleNumber, { number: 2 }),
        React.createElement(CenteredTitle, { weight: 400 },
            "Connectez-vous ou ",
            React.createElement("b", null, "rejoignez le Club R"))),
    React.createElement(ImageContainer, { bottom: -22, isCenter: true },
        React.createElement("img", { src: "https://fr.shopping.rakuten.com/visuels/0_next-common/club-r-pay/phone352x257.png", width: 176 }))));
const FourthCard = ({ partnerName }) => (React.createElement(CardContainer, { padding: 40 },
    React.createElement(TitleContainer, null,
        React.createElement(CircleNumber, { number: 3 }),
        React.createElement(TextContainer, null,
            React.createElement(CenteredTitle, { weight: 400 }, "Votre offre est activ\u00E9e !"),
            React.createElement(CenteredTitle, { weight: 600 },
                "Vous pouvez faire vos achats sur ",
                partnerName))),
    React.createElement(ImageContainer, { bottom: 18, isCenter: true },
        React.createElement(CheckImageContainer, null,
            React.createElement("img", { src: "https://fr.shopping.rakuten.com/visuels/0_next-common/club-r-pay/CartChecked160x160.png", height: 80 }),
            React.createElement(Check, { style: CheckIcon })))));
export const carouselItems = [
    {
        id: 0,
        content: () => React.createElement(FirstCard, null),
    },
    {
        id: 1,
        content: () => React.createElement(SecondCard, null),
    },
    {
        id: 2,
        content: () => React.createElement(ThirdCard, null),
    },
    {
        id: 3,
        content: (props) => React.createElement(FourthCard, Object.assign({}, props)),
    },
];
